import React, { useState, useRef } from 'react'
import { MobileNavigationProps, MobileNavState } from './Navigation.types'
import './App.scss'

/**
 * Mobile Navigation for CRG Site
 * @param {Function} onClick will close the overall mobile nav
 * @param {Array[Object]} menuItems Name and URL to be displayed from BRE menu
 * @returns
 */
const MobileNavigation = (props: MobileNavigationProps) => {
  const { onClick, menuItems } = props

  const [currentMenuItems, setCurrentMenuItems] = useState<MobileNavState>({
    current: [...menuItems],
    previous: [],
    currentLinks: [],
  })
  if (menuItems.length) {
    const event = new Event('NavLoaded')
    document.dispatchEvent(event)
  }

  const backRef = useRef(null) as unknown as React.RefObject<HTMLButtonElement>

  return (
    <div className='amp-mobile-nav u-lg-hidden'>
      <div className='amp-nav amp-nav--fullHeight'>
        <div className='u-sizeConstrained amp-nav-inner u-flex Popover amp-nav-level-one is-visible'>
          <nav className='u-flex u-flexCol u-flexAlignItemsStretch amp-nav-level-one u-sizeFull u-posRelative'>
            <ul className='List List--selectable List--inline amp-mainNav u-flex u-flexCol u-flexJustifyStart u-decoBorderResetBottom'>
              {currentMenuItems.previous.length ? (
                <>
                  <li
                    className='List-item amp-mainNav-item u-decoBorderLight u-decoBorderResetTop u-lg-hidden u-padding0 u-posRelative'
                    onClick={() => {
                      const newPrevious = [...currentMenuItems.previous]
                      const newCurrent = [...newPrevious[newPrevious.length - 1]]
                      const newCurrentLinks = [...currentMenuItems.currentLinks]
                      newCurrentLinks.pop()

                      newPrevious.pop()
                      setCurrentMenuItems({
                        ...currentMenuItems,
                        current: [...newCurrent],
                        previous: [...newPrevious],
                        currentLinks: [...newCurrentLinks],
                      })
                      backRef?.current?.focus()
                    }}>
                    <button
                      ref={backRef}
                      data-icon='&#xe314;'
                      data-analytics='back button'
                      className='Link u-linkClean u-flex u-sizeFull u-paddingVert3gu u-paddingLeft2gu u-paddingRight4gu'>
                      <span
                        className='adel-material-symbols-18 u-textColorInherit'
                        role='img'
                        aria-label='Chevron Left'>
                        chevron_left
                      </span>
                      <span className='u-marginLeft1gu u-textSizeMsrm1'>{'Back'}</span>
                    </button>
                  </li>

                  <li
                    className='List-item amp-mainNav-item u-decoBorderLight u-decoBorderResetTop u-lg-hidden u-padding0 u-bgColorLight'
                    onClick={onClick}>
                    <a
                      className='amp-mainNav-link u-textSizeMsrm1 u-textNoWrap u-posRelative u-paddingVert3gu u-paddingHoriz4gu u-textColorDefault'
                      rel='noopener noreferrer'
                      href={
                        currentMenuItems?.currentLinks[currentMenuItems?.currentLinks?.length - 1]
                          ?.url || ''
                      }
                      data-analytics={
                        currentMenuItems?.currentLinks[currentMenuItems?.currentLinks?.length - 1]
                          ?.name || ''
                      }>
                      <span>
                        {
                          currentMenuItems?.currentLinks[currentMenuItems?.currentLinks?.length - 1]
                            ?.name
                        }
                      </span>
                    </a>
                  </li>
                </>
              ) : null}
              {currentMenuItems.current.map((item, index) => {
                const showDropdown =
                  item?.HstMenuItemRepresentation?.parameters?.showDropdown &&
                  item?.HstMenuItemRepresentation?.parameters?.showDropdown === 'false'
                    ? false
                    : true
                const {
                  HstMenuItemRepresentation: { name, url, menuItems: subMenuItems = [] },
                } = item
                const className = `List-item amp-mainNav-item${
                  index === currentMenuItems.current.length - 1
                    ? ''
                    : ' u-decoBorderLight u-decoBorderResetTop'
                } u-lg-hidden u-padding0`
                const buttonClassName = `u-paddingVert3gu ${
                  currentMenuItems.previous.length
                    ? 'u-paddingHoriz3gu u-paddingLeft8gu'
                    : 'u-paddingHoriz3gu u-paddingLeft4gu'
                }`
                return (
                  <li
                    className={className}
                    key={name}
                    onClick={() => {
                      if (subMenuItems.length && showDropdown) {
                        const newPrevious = [...currentMenuItems.previous]
                        newPrevious.push([...currentMenuItems.current])
                        const newCurrentLink = {
                          name,
                          url,
                        }
                        const newCurrentLinks = [...currentMenuItems.currentLinks]
                        newCurrentLinks.push({ ...newCurrentLink })
                        setCurrentMenuItems({
                          ...currentMenuItems,
                          current: [...subMenuItems],
                          previous: [...newPrevious],
                          currentLinks: [...newCurrentLinks],
                        })
                        backRef?.current?.focus()
                      } else {
                        onClick()
                      }
                    }}>
                    {subMenuItems.length && showDropdown ? (
                      <button
                        data-analytics={name}
                        className={`Link Link--trigger u-linkClean u-textSizeMsrm1 u-flex u-flexJustifyBetween u-sizeFull ${buttonClassName}`}>
                        {name}
                      </button>
                    ) : (
                      <a
                        className={`amp-mainNav-link u-textSizeMsrm1 u-textNoWrap u-posRelative ${buttonClassName}`}
                        rel='noopener noreferrer'
                        href={!(subMenuItems.length && showDropdown) ? url : undefined}
                        data-analytics={name}>
                        {name}
                      </a>
                    )}
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default MobileNavigation
